import { faTrashAlt, faUserPlus } from "@fortawesome/pro-regular-svg-icons";
import {
    faBalanceScaleLeft,
    faChartLine,
    faCog,
    faCompressAlt,
    faPen,
    faPencil,
    faSearch,
    faTrash,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import React from "react";
import { MapStateToPropsParam } from "react-redux";

import { analyticsStoreEvent } from "@/mk2/actions";
import { adminclubXMLImportItemsUrl } from "@/mk2/apps/adminclub/urls";
import {
    ProductEntity,
    ProductSchema,
    XMLImportItemEntity,
    XMLImportItemSchema,
} from "@/mk2/apps/bazaar/schemas";
import {
    DateRange1,
    KeywordFilterType,
} from "@/mk2/apps/dash/containers/SeoPerformance/FilterForm";
import { dashSeoPerformaceUrl } from "@/mk2/apps/dash/urls";
import { TopicEntity, TopicSchema } from "@/mk2/apps/forum/schemas";
import { StrollersBuyingGuides } from "@/mk2/apps/strollers/components/StrollersBuyingGuides";
import {
    strollersComparisonLoad,
    strollersComparisonToggle,
} from "@/mk2/apps/strollers/containers/StrollersComparison/StrollersComparison.actions";
import strollersComparisonReducer from "@/mk2/apps/strollers/containers/StrollersComparison/StrollersComparison.reducers";
import strollersComparisonSaga from "@/mk2/apps/strollers/containers/StrollersComparison/StrollersComparison.sagas";
import { getStrollersComparisonState } from "@/mk2/apps/strollers/containers/StrollersComparison/StrollersComparison.selectors";
import { StrollersDetail } from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail";
import {
    LinkedObjects,
    strollersDetailAddToProfile,
    strollersDetailChangeVariantFeatureValueTrigger,
    strollersDetailDeleteStrollerTrigger,
    strollersDetailFetchTrigger,
    strollersDetailLoadMoreSimilarsTrigger,
    strollersDetailRemoveFromProfile,
} from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.actions";
import { STROLLERS_DETAIL_MENU_MORE } from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.constants";
import styles from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.mscss";
import reducer from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.reducers";
import saga from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.sagas";
import { getStrollersDetailState } from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.selectors";
import { PageMode } from "@/mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.constants";
import {
    breadcrumbsStroller,
    productSchemaStroller,
    strollerOG,
} from "@/mk2/apps/strollers/structuredData";
import {
    strollersComparisonUrl,
    strollersDetailUrl,
    strollersEditDescription,
    strollersListUrl,
    strollersMergeUrl,
    strollersPhotoEditorUrl,
    strollersRenameUrl,
    strollersSearchUrl,
    strollersUrl,
} from "@/mk2/apps/strollers/urls";
import { loginUrl } from "@/mk2/apps/users/urls";
import { Btn, BtnCountType, BtnLayout, BtnType } from "@/mk2/components/Btn";
import { Panel } from "@/mk2/components/Panel";
import { MenuItem } from "@/mk2/components/menu/MenuItem";
import { Menu } from "@/mk2/containers/Menu/Menu";
import { menuToggle } from "@/mk2/containers/Menu/Menu.actions";
import { cacheLast } from "@/mk2/helpers/cache";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { url } from "@/mk2/helpers/urls";
import Page, { HalfpageProps, PageRouteProps } from "@/mk2/pages/Page";
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from "@/mk2/reducers";
import { LoadingState, isLoading } from "@/mk2/reducers/loadingState";
import {
    AST,
    ASTAdditionalDataFromServer,
    BlogPostEntity,
    BlogPostSchema,
    ContentItemEntity,
    ContentItemSchema,
    EshopProductEntity,
    EshopProductSchema,
    PhotoDetailSchema,
    PhotoEntity,
    PhotoSchema,
    StrollerEntity,
    StrollerPatternEntity,
    StrollerPatternSchema,
    StrollerPhoto,
    StrollerQuestionEntity,
    StrollerQuestionSchema,
    StrollerSchema,
    StrollerUserReviewEntity,
    StrollerUserReviewSchema,
    StrollerVariantEntity,
    StrollerVariantSchema,
    UserEntity,
    VariantsOptionsEntity,
} from "@/mk2/schemas";
import { getDenormalizedEntities, getDenormalizedEntity } from "@/mk2/selectors";
import { HistoryLocationWithState } from "@/mk2/services/browserHistory";
import { Store } from "@/mk2/store/configureStore";
import {
    SEO_TITLE_STROLLER_COMPONENT_DETAILED_REVIEW,
    SEO_TITLE_STROLLER_COMPONENT_FORUM,
    SEO_TITLE_STROLLER_COMPONENT_REVIEWS,
    SEO_TITLE_STROLLER_COMPONENT_VIDEO,
    SEO_TITLE_STROLLER_COMPONENT_WHERE_TO_BUY,
    STROLLER_CARD_COMPARE,
    STROLLER_CARD_COMPARE_REMOVE,
    STROLLER_DETAIL_ADD_TO_PROFILE,
    STROLLER_DETAIL_REMOVE_FROM_PROFILE,
    STROLLER_DETAIL_SEAERCH_STROLLER,
} from "@/mk/autogenerated/translation";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";

const fasCogLg: FontAwesomeIconProps = { icon: faCog, size: "lg" };

interface OwnProps {}

interface StateProps {
    slug: string;
    stroller: StrollerEntity;
    strollerPhotos: StrollerPhoto[];
    relatedStrollersPreviewPhotos: Record<number, number>;
    strollerVariantsPhotosMap: Record<number, StrollerPhoto>;
    variantsPhotoIds: Record<number, number[]>;
    variants: StrollerVariantEntity[];
    variantsOptions: VariantsOptionsEntity;
    variantId?: number;
    baseVariantId: number;
    patterns: StrollerPatternEntity[];
    strollerQuestions: StrollerQuestionEntity[];
    strollerReviews: StrollerUserReviewEntity[]; // schvalene recenzie kocika 'stroller' alebo jeho suvisiacich modelov
    strollerPendingReviews: StrollerUserReviewEntity[]; // recenzie kocika 'stroller' cakajuce na schvalenie
    strollerAlikeStrollers: StrollerEntity[]; // suvisiace kociky s podobnymi vlastnostami ako 'stroller'
    similars: StrollerEntity[];
    strollersOfThisBrand: StrollerEntity[];
    loadingState: LoadingState;
    errorMessage: string;
    isInComparison: boolean;
    comparison: number[];
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isAdmin: boolean;
    isMobile: boolean;
    onProfile: boolean;
    addingToProfileLoadingState: LoadingState;
    removingFromProfileLoadingState: LoadingState;
    loadMoreSimilarsLoadingState: LoadingState;
    hasMoreSimilars: boolean;
    countOfSimilars: number;
    oldProductsCount: number;
    cheapestOldProduct: ProductEntity;

    allEshopProducts: XMLImportItemEntity[];

    buyingGuide: ContentItemEntity;
    baseUrl: string;
    linkedObjects: LinkedObjects;
    counselling: TopicEntity;
    articles: BlogPostEntity[];
    descriptionAST: AST;
    descriptionASTAdditionalData: ASTAdditionalDataFromServer;
    descriptionPhotos: PhotoEntity[];

    eshopProductsWidget: EshopProductEntity[];
}

interface DispatchProps {
    onLoad(slug: string, variantId?: number);
    onLoadMoreSimilars(slug: string, offset: number);
    onComparisonLoad();
    onComparisonToggle(strollerId: number, location: HistoryLocationWithState);
    onStrollerToggleMenuMore();
    onStrollerDelete(strollerId: number);
    onAddToProfile(slug: string, strollerId: number, username: string);
    onRemoveFromProfile(slug: string, strollerId: number, username: string);
    onStoreEvent(name: string, props: any, redirect?: string);
    onChangeVariantFeatureValue(
        slug: string,
        configFeatureName: string,
        value: string,
        linkedId: number,
    );
}

type RouteProps = PageRouteProps<{ slug: string; variantId?: string }>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class StrollersDetailPage extends Page<
    OwnProps & RouteProps,
    StateProps,
    DispatchProps
> {
    private handleOnDelete = cacheLast();
    private handleProfileToggleCache = cacheLast();
    private handleComparisonToggleCache = cacheLast();

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const requestUser = getRequestUser(state);
            const requestUserPermissions = getRequestPermissions(state);

            const slug = ownProps.routeParams.slug;
            const variantId = parseInt(ownProps.routeParams.variantId, 10);

            const strollerDetailState = variantId
                ? getStrollersDetailState(state, slug, variantId)
                : getStrollersDetailState(state, slug);
            const stroller = getDenormalizedEntity<StrollerEntity>(
                state,
                StrollerSchema,
                strollerDetailState.strollerId,
            );
            const variants = getDenormalizedEntities<StrollerVariantEntity>(
                state,
                StrollerVariantSchema,
                strollerDetailState.variantsIds,
            );
            const variantsOptions = strollerDetailState.variantsOptions;
            const baseVariantId = strollerDetailState.baseVariantId;
            const strollerReviews = getDenormalizedEntities<StrollerUserReviewEntity>(
                state,
                StrollerUserReviewSchema,
                strollerDetailState.strollerReviewIds,
            );
            const strollerPendingReviews = getDenormalizedEntities<StrollerUserReviewEntity>(
                state,
                StrollerUserReviewSchema,
                strollerDetailState.strollerPendingReviewIds,
            );
            const strollerAlikeStrollers = getDenormalizedEntities<StrollerEntity>(
                state,
                StrollerSchema,
                strollerDetailState.strollerAlikeStrollerIds,
            );
            const patterns = getDenormalizedEntities<StrollerPatternEntity>(
                state,
                StrollerPatternSchema,
                strollerDetailState.patternsIds,
            );
            const comparisonState = getStrollersComparisonState(state);

            const strollerPhotos = getDenormalizedEntities<StrollerPhoto>(
                state,
                PhotoDetailSchema,
                strollerDetailState.strollerPhotosIds,
            );

            const allStrollerPhotos = getDenormalizedEntities<StrollerPhoto>(
                state,
                PhotoDetailSchema,
                strollerDetailState.allStrollerPhotosIds,
            );
            const strollerVariantsPhotosMap = {};
            allStrollerPhotos.map(
                (strollerPhoto) => (strollerVariantsPhotosMap[strollerPhoto.id] = strollerPhoto),
            );
            const variantsPhotoIds = strollerDetailState.variantsPhotos;
            const relatedStrollersPreviewPhotos = strollerDetailState.relatedStrollersPreviewPhotos;

            const eshopProductsWidget = getDenormalizedEntities<EshopProductEntity>(
                state,
                EshopProductSchema,
                strollerDetailState.eshopProductsWidgetIds,
            );

            const allEshopProducts = getDenormalizedEntities<XMLImportItemEntity>(
                state,
                XMLImportItemSchema,
                strollerDetailState.eshopProductsIds,
            );

            const descriptionAST = strollerDetailState.descriptionAST;
            const descriptionASTAdditionalData = strollerDetailState.descriptionASTAdditionalData;
            const descriptionPhotos = getDenormalizedEntities<PhotoEntity>(
                state,
                PhotoSchema,
                strollerDetailState.descriptionPhotos,
            );

            return {
                slug,
                stroller,
                strollerPhotos,
                relatedStrollersPreviewPhotos,
                strollerVariantsPhotosMap,
                variantsPhotoIds,
                variants,
                variantsOptions,
                variantId,
                baseVariantId,
                patterns,
                similars: strollerDetailState.similarIds
                    ? getDenormalizedEntities<StrollerEntity>(
                          state,
                          StrollerSchema,
                          strollerDetailState.similarIds,
                      )
                    : null,
                strollersOfThisBrand: strollerDetailState.strollersOfThisBrandIds
                    ? getDenormalizedEntities<StrollerEntity>(
                          state,
                          StrollerSchema,
                          strollerDetailState.strollersOfThisBrandIds,
                      )
                    : null,
                strollerReviews,
                strollerPendingReviews,
                strollerAlikeStrollers,
                strollerQuestions: getDenormalizedEntities<StrollerQuestionEntity>(
                    state,
                    StrollerQuestionSchema,
                    strollerDetailState.strollerQuestionIds,
                ),
                loadingState: strollerDetailState.loadingState,
                errorMessage: strollerDetailState.errorMessage,
                isInComparison: stroller ? comparisonState.allIds.includes(stroller.id) : false,
                comparison: comparisonState.allIds,
                requestUser,
                requestUserPermissions,
                isAdmin: requestUserPermissions.indexOf("auth.can_manage_strollers") >= 0,
                isMobile: getRequestDeviceMobile(state),
                onProfile: strollerDetailState.onProfile,
                addingToProfileLoadingState: strollerDetailState.addingToProfileLoadingState,
                removingFromProfileLoadingState:
                    strollerDetailState.removingFromProfileLoadingState,
                loadMoreSimilarsLoadingState: strollerDetailState.loadMoreSimilarsLoadingState,
                hasMoreSimilars: strollerDetailState.hasMoreSimilars,
                countOfSimilars: strollerDetailState.countOfSimilars,
                oldProductsCount: strollerDetailState.oldProductsCount,
                cheapestOldProduct: getDenormalizedEntity<ProductEntity>(
                    state,
                    ProductSchema,
                    strollerDetailState.cheapestOldProductId,
                ),

                allEshopProducts,

                buyingGuide: getDenormalizedEntity<ContentItemEntity>(
                    state,
                    ContentItemSchema,
                    strollerDetailState.buyingGuideId,
                ),
                counselling: getDenormalizedEntity<TopicEntity>(
                    state,
                    TopicSchema,
                    strollerDetailState.counsellingId,
                ),
                baseUrl: getRequestBaseUrl(state),
                linkedObjects: strollerDetailState.linkedObjects,
                articles: getDenormalizedEntities<BlogPostEntity>(
                    state,
                    BlogPostSchema,
                    strollerDetailState.articleIds,
                ),
                descriptionAST,
                descriptionASTAdditionalData,
                descriptionPhotos,

                eshopProductsWidget,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: strollersDetailFetchTrigger,
            onLoadMoreSimilars: strollersDetailLoadMoreSimilarsTrigger,
            onComparisonToggle: strollersComparisonToggle,
            onComparisonLoad: strollersComparisonLoad,
            onStrollerToggleMenuMore: () => menuToggle(STROLLERS_DETAIL_MENU_MORE),
            onAddToProfile: strollersDetailAddToProfile,
            onRemoveFromProfile: strollersDetailRemoveFromProfile,
            onStrollerDelete: strollersDetailDeleteStrollerTrigger,
            onStoreEvent: analyticsStoreEvent,
            onChangeVariantFeatureValue: strollersDetailChangeVariantFeatureValueTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        const {
            stroller,
            strollerReviews,
            strollerQuestions,
            cheapestOldProduct,
            allEshopProducts,
            linkedObjects,
        } = props;

        if (stroller) {
            let ret = `${stroller.name} - ${SEO_TITLE_STROLLER_COMPONENT_REVIEWS}`;
            if (cheapestOldProduct || allEshopProducts.length) {
                ret += `, ${SEO_TITLE_STROLLER_COMPONENT_WHERE_TO_BUY}`;
            }
            if (stroller.features.video_url?.length) {
                ret += `, ${SEO_TITLE_STROLLER_COMPONENT_VIDEO}`;
            }
            if (strollerReviews.some((r) => r.detailedReview)) {
                ret += `, ${SEO_TITLE_STROLLER_COMPONENT_DETAILED_REVIEW}`;
            }
            if (strollerQuestions?.length || linkedObjects.length) {
                ret += `, ${SEO_TITLE_STROLLER_COMPONENT_FORUM}`;
            }
            return ret;
        } else {
            return null;
        }
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        const { stroller } = props;

        if (stroller) {
            return baseUrl + url(strollersDetailUrl, { slug: stroller.slug });
        }
    }

    public getMetaDescription(props: Props): string {
        const { stroller } = props;
        if (stroller) {
            // https://trello.com/c/3g0szBSD
            // Kočíkopedia meta description: prázdný
            return "";
        }
    }

    public getOpenGraphData(
        props: Props,
        baseUrl: string,
        currentUrl: string,
    ): { [key: string]: string } {
        const { stroller, descriptionAST } = props;
        if (stroller) {
            return {
                ...super.getOpenGraphData(props, baseUrl, currentUrl),
                ...strollerOG(baseUrl, stroller, descriptionAST),
            };
        }
    }

    public render(props: Props): false | JSX.Element {
        return <StrollersDetail {...props} />;
    }

    public getHeaderRight(props: Props): React.ReactElement {
        const {
            requestUserPermissions,
            stroller,
            baseVariantId,
            onStrollerToggleMenuMore,
            onStrollerDelete,
            comparison,
            isInComparison,
            onProfile,
            addingToProfileLoadingState,
            removingFromProfileLoadingState,
            onComparisonToggle,
            location,
        } = props;

        const hasSeoStats =
            stroller && requestUserPermissions.indexOf("users.can_access_dash") >= 0;
        const hasDelete = stroller && requestUserPermissions.indexOf("wiki.can_edit_wiki") >= 0;
        const hasShowXmlFeedItems =
            stroller && requestUserPermissions.indexOf("auth.can_manage_strollers") >= 0;
        const hasRename =
            stroller && requestUserPermissions.indexOf("auth.can_manage_strollers") >= 0;
        const hasMerge =
            stroller && requestUserPermissions.indexOf("auth.can_manage_strollers") >= 0;
        const hasDescriptionEdit =
            stroller && requestUserPermissions.indexOf("auth.can_manage_strollers") >= 0;

        const elements = [];

        // comparison
        elements.push(
            <Btn
                type={BtnType.BlueText}
                layout={BtnLayout.Icon}
                icon={faBalanceScaleLeft}
                count={comparison.length}
                countType={BtnCountType.Circle}
                link={strollersComparisonUrl}
                onClick={this.handleComparisonToggleCache(() =>
                    onComparisonToggle(stroller.id, location),
                )}
            />,
        );

        // cog menu
        if (stroller && (hasSeoStats || hasDelete || hasShowXmlFeedItems)) {
            elements.push(
                <Menu
                    key="menu"
                    menuId={STROLLERS_DETAIL_MENU_MORE}
                    trigger={
                        <Btn
                            type={BtnType.BlueText}
                            icon={fasCogLg}
                            onClick={onStrollerToggleMenuMore}
                        />
                    }
                >
                    <MenuItem
                        type={BtnType.BlueText}
                        label={STROLLER_DETAIL_SEAERCH_STROLLER}
                        icon={faSearch}
                        link={url(strollersSearchUrl, { pageMode: PageMode.SHOW_SEARCH_FORM })}
                    />
                    <MenuItem
                        type={isInComparison ? BtnType.RedText : undefined}
                        label={
                            isInComparison ? STROLLER_CARD_COMPARE_REMOVE : STROLLER_CARD_COMPARE
                        }
                        icon={faBalanceScaleLeft}
                        onClick={this.handleComparisonToggleCache(() =>
                            onComparisonToggle(stroller.id, location),
                        )}
                        disabled={Boolean(stroller.deletedAt)}
                    />
                    <MenuItem
                        type={onProfile ? BtnType.RedText : undefined}
                        label={
                            onProfile
                                ? STROLLER_DETAIL_REMOVE_FROM_PROFILE
                                : STROLLER_DETAIL_ADD_TO_PROFILE
                        }
                        icon={onProfile ? faTrashAlt : faUserPlus}
                        onClick={this.handleProfileToggleCache(
                            () => this.handleProfileToggle(props),
                            props.requestUser,
                            props.location,
                            props.slug,
                            props.stroller,
                            props.onProfile,
                        )}
                        disabled={
                            Boolean(stroller.deletedAt) ||
                            addingToProfileLoadingState === LoadingState.LOADING ||
                            removingFromProfileLoadingState === LoadingState.LOADING
                        }
                    />
                    {hasDelete && (
                        <MenuItem
                            label="Delete stroller"
                            icon={faTrash}
                            onClick={this.handleOnDelete(
                                () => onStrollerDelete(stroller.id),
                                stroller.id,
                            )}
                            disabled={!!stroller.deletedAt}
                            isAdminUI
                        />
                    )}
                    {hasRename && (
                        <MenuItem
                            label="Rename"
                            icon={faPen}
                            link={url(strollersRenameUrl, { strollerId: stroller.id }, {})}
                            isAdminUI
                        />
                    )}
                    {hasMerge && (
                        <MenuItem
                            label="Merge"
                            icon={faCompressAlt}
                            link={url(strollersMergeUrl, { strollerId: stroller.id }, {})}
                            isAdminUI
                        />
                    )}
                    {hasDescriptionEdit && (
                        <MenuItem
                            label="Edit Description"
                            icon={faPencil}
                            link={url(strollersEditDescription, { strollerId: stroller.id }, {})}
                            isAdminUI
                        />
                    )}
                    {hasSeoStats && (
                        <MenuItem
                            label="SEO traffic"
                            icon={faChartLine}
                            link={url(
                                dashSeoPerformaceUrl,
                                {},
                                {
                                    range1: DateRange1[DateRange1.Past12Weeks],
                                    urls: `pageid:strollers-stroller-${stroller.id}`,
                                    keywords: KeywordFilterType[KeywordFilterType.NonBranded],
                                },
                            )}
                            asAnchor
                            linkTarget="_blank"
                            isAdminUI
                        />
                    )}
                    {hasShowXmlFeedItems && (
                        <MenuItem
                            label="XML feed items"
                            icon={faCog}
                            link={url(
                                adminclubXMLImportItemsUrl,
                                {},
                                {
                                    strollerId: stroller.id,
                                },
                            )}
                            isAdminUI
                        />
                    )}
                    {hasShowXmlFeedItems && (
                        <MenuItem
                            disabled={!baseVariantId}
                            label="Edit variant photos"
                            icon={faCog}
                            link={url(strollersPhotoEditorUrl, { strollerId: stroller.id }, {})}
                            isAdminUI
                        />
                    )}
                </Menu>,
            );
        }

        return (
            <>
                {elements.map((element, idx) => (
                    <React.Fragment key={idx}>
                        {idx > 0 && "\u00A0\u00A0"}
                        {element}
                    </React.Fragment>
                ))}
            </>
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return props.stroller?.brand?.slug
            ? url(strollersListUrl, { slug: props.stroller?.brand?.slug })
            : strollersUrl;
    }

    public renderRight(props: Props): JSX.Element {
        return (
            !!props.buyingGuide && (
                <Panel className={styles.StrollersDetail__buyingGuides}>
                    <StrollersBuyingGuides buyingGuideContentItem={props.buyingGuide} />
                </Panel>
            )
        );
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return props.stroller?.deletedAt
            ? null
            : {
                  zone: "Strollers Index - Halfpage Sticky (Desktop)",
              };
    }

    public hasMobileLogo(props: Props): boolean {
        return true;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer("containers.strollers.strollersDetail", reducer);
        store.injectSaga("containers.strollers.strollersDetail", saga);

        store.injectReducer("containers.strollers.strollersComparison", strollersComparisonReducer);
        store.injectSaga("containers.strollers.strollersComparison", strollersComparisonSaga);
    }

    public getStructuredData(props: Props): object[] {
        const {
            stroller,
            descriptionAST,
            baseUrl,
            strollerReviews,
            allEshopProducts,
            cheapestOldProduct,
            loadingState,
        } = props;
        if (!stroller || isLoading(loadingState)) {
            return [];
        }
        const data: object[] = [breadcrumbsStroller(baseUrl, stroller)];
        data.push(
            productSchemaStroller(
                baseUrl,
                stroller,
                descriptionAST,
                strollerReviews,
                allEshopProducts,
                cheapestOldProduct,
            ),
        );
        return data;
    }

    private handleProfileToggle = (props: Props) => {
        const {
            requestUser,
            history,
            location,
            onProfile,
            onAddToProfile,
            onRemoveFromProfile,
            slug,
            stroller,
        } = props;
        if (!isAuthenticated(requestUser)) {
            history.push(
                url(
                    loginUrl,
                    {},
                    { next: `${location.pathname}${location.search}${location.hash}` },
                ),
            );
            return;
        }

        if (onProfile) {
            onRemoveFromProfile(slug, stroller.id, requestUser.username);
        } else {
            onAddToProfile(slug, stroller.id, requestUser.username);
        }
    };
}
